import { LDEvaluationDetail, ProviderConfig } from 'launchdarkly-react-client-sdk';
import { datadogRum } from '@datadog/browser-rum';
import { FeatureFlagKeys } from '@utils/constants';

export const launchDarklyConfig: ProviderConfig = {
  clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID ?? 'fake_id',
  options: {
    bootstrap: {
      [FeatureFlagKeys.CbaAcceptedQuotePackageScreen]: null,
      [FeatureFlagKeys.Maintenance]: {
        enableMaintenance: false,
        endDate: '',
        endTime: '',
      },
      [FeatureFlagKeys.ProceedToApplicationForm]: true,
      [FeatureFlagKeys.UniversalLogin]: false,
    },
    inspectors: [
      {
        type: 'flag-used',
        name: 'dd-inspector',
        method: (key: string, detail: LDEvaluationDetail) => {
          datadogRum.addFeatureFlagEvaluation(key, detail.value);
        },
      },
    ],
  },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  flags: {
    [FeatureFlagKeys.CbaAcceptedQuotePackageScreen]: null,
    [FeatureFlagKeys.Maintenance]: { enableMaintenance: false },
    [FeatureFlagKeys.ProceedToApplicationForm]: true,
    [FeatureFlagKeys.UniversalLogin]: false,
  },
};
